<template>
<v-layout row wrap>
  <v-flex xs12>
    <v-card>
      <v-data-table
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :total-items="totalCount"
        :headers="headers"
        :items="datas"
        :loading="loading">
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded" style="cursor:pointer;">
            <td>{{ props.item.dateSummary }}</td>
            <td>{{ props.item.serialNumber }}</td>
            <td>{{ props.item.values }}</td>
            <td>
              <v-sheet
                class="v-sheet--offset mx-auto"
                width="100px">
              <v-sparkline
                :value="[0, ...props.item.values, 0]"
                line-width="1"
              ></v-sparkline>
            </v-sheet>
            </td>
          </tr>
        </template>

        <template v-slot:expand="props">
          <v-card flat>
            <v-card-text>
              cmd = {{ $_cmdToHex(props.item.cmd) }}, original value = {{ props.item.originValues }}
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>

  <!--
  <v-btn fixed dark fab bottom right color="pink"
    @click="$router.push({name:'PlugAdd'})">
    <v-icon>add</v-icon>
  </v-btn>
  -->
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import moment from 'moment'
import {Util} from '../Util'

export default {
  name: 'HelloWorld',
  data () {
    return {
      headers: [{text: '충전시각', values: 'date', sortable: false},
        {text: 'serialNumber', values: 'serialNumber', sortable: false},
        {text: 'values', values: 'values', sortable: false},
        {text: 'chart', values: 'chart', sortable: false}],
      datas: [],
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      totalCount: 0, // https://stackoverflow.com/questions/46554091/firebase-firestore-collection-count, https://firebase.google.com/docs/firestore/solutions/counters
      prevStartAt: [],
      loading: false
      // items: [{ header: '플러그 목록' }]
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getTotalCount()
      this.$_getPlugReports()
    },
    pagination (_new, old) {
      if (old.page === 1 && _new.page === 1) { // 최초
        this.$_getPlugReports()
      } else if (old.page < _new.page) { // 다음
        // console.log("page = ", _new.page, this.pagination.rowsPerPage * _new.page - 1, this.datas[this.pagination.rowsPerPage * old.page - 1])
        // console.log(this.datas[this.pagination.rowsPerPage * old.page - 1])
        this.prevStartAt[old.page - 1] = this.datas[0]
        this.$_getPlugReports(this.datas[this.pagination.rowsPerPage - 1], true)
      } else if (old.page > _new.page) { // 이전
        this.$_getPlugReports(this.prevStartAt[_new.page - 1], false)
      }
    }
  },
  created () {
    this.$emit('title', '충전 기록')
    this.$_getTotalCount()
  },
  methods: {
    $_cmdToHex (cmd) {
      try {
        if (cmd) {
          return '0x' + cmd.toString(16)
        } else {
          return 'null'
        }
      } catch (error) {
        return cmd + `(${error})`
      }
    },
    $_getTotalCount () {
      firebase.firestore().collection('counters')
        .doc('plug_reports_daejeon')
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.exists) {
            // console.log(querySnapshot, querySnapshot.data())
            this.totalCount = querySnapshot.data().numberOfDocs
          }
        })
    },
    $_getPlugReports (startRefDoc, isNext) {
      this.loading = true
      /*
      this.$fs.collection('plug_reports')
      .where("serialNumber", "==", "80589258")
      .get()
      .then((querySnapshot) => {
        console.log(querySnapshot.docs)

        //querySnapshot.foreach((querySnapshot.docs) => {

        //})
        for (var i = 0; i < querySnapshot.docs.length; i++) {
          querySnapshot.docs[i].ref.delete()
        }
      })
      return;
      */

      let query = this.$fs.collection('plug_reports').where('group', '==', this.$store.state.session.group).orderBy('created', 'desc')

      if (startRefDoc) {
        if (isNext) {
          console.log(startRefDoc, isNext)
          query = query.startAfter(startRefDoc.created) // next 페이지는 startAfter, prev 페이지는 startAt
        } else {
          query = query.startAt(startRefDoc.created)
        }
      }

      query.limit(this.pagination.rowsPerPage)
        .get()
        .then((querySnapshot) => {
          this.datas = []
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)
            // console.log(doc.data())

            var item = doc.data()
            item.id = doc.id

            var createdTime = item.created.toDate().getTime()
            var updatedTime = item.updated ? item.updated.toDate().getTime() : createdTime

            // console.log('before', item.values)
            item.originValues = Array.from(item.values) // copy array

            // 조도값 데이터 제거
            item.values = Util.illuminanceValueFilter(item.originValues)

            // console.log('after', item.values)

            var startedTime = moment(updatedTime).subtract({minutes: 5 * item.values.length})
            item.dateSummary = moment(startedTime).format('YYYY-MM-DD HH:mm') +
              ' ~ ' + moment(updatedTime).format('HH:mm')
            this.datas.push(item)
            // this.datas[++dataIndex]
            // this.items.push({ divider: true, inset: false })
            // console.log(doc.data())
          })

          this.loading = false
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
          }
          this.loading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Plug/PlugReportList.vue